import React from 'react';
import type { FC } from 'react';

interface EditIconProps {
    className?: string;
}

export const EditIcon: FC<EditIconProps> = ({ className }) => {
    return (
        <svg
            className={className}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Edit Icon</title>
            <path
                d="M16.6473 5.44642L14.5544 3.35353C14.3591 3.15827 14.0425 3.15827 13.8473 3.35353L5.88427 11.3165C5.82939 11.3714 5.78803 11.4383 5.76349 11.512L4.40078 15.6L8.48884 14.2373C8.56247 14.2127 8.62939 14.1714 8.68427 14.1165L16.6473 6.15353C16.8425 5.95827 16.8425 5.64168 16.6473 5.44642Z"
                strokeLinejoin="round"
            />
            <path d="M14.1953 8.60034L11.3953 5.80034" />
            <path d="M8.59766 14.2004L5.79764 11.4004" />
        </svg>
    );
};
